/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE11 requires all of the following polyfills. **/
// import 'core-js/es/array';
// import 'core-js/es/object';

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
